// extracted by mini-css-extract-plugin
export default {"switch-button":"switchButton_switch-button__L10-c","switch-button--active":"switchButton_switch-button--active__1j22D"};